import React, { Component, useState } from 'react';
import { Redirect } from 'react-router';

import TableWidget from "../widgets/TableWidget";

import AccountStateButton from "../widgets/AccountStateButton";
import AccountOverdueButton from "../widgets/AccountOverdueButton";


import { useHistory } from "react-router-dom";

import queryString from "query-string";

const AllAccountsSummary = function (props) {

    const history = useHistory();

    console.log(history);

    let params = queryString.parse(history.location.search)


    props.store.updateBanner("All Accounts Summary");

    function redirectToAccountStatus(event) {
        console.log(event)
        //let accountId = event.target.value;
    
        //history.push("/staff/AccountStatus/" + accountId);
    }

    let overdueFilter = params.overdueFilter;


    const [accountStatusFilter, setAccountStatusFilter] = useState("All");
    const [accountOverdueFilter, setAccountOverdueFilter] = useState(overdueFilter ? overdueFilter : "All");

    function updateAccountStatusFilter(event) {
        console.log(event.target.value)
        setAccountStatusFilter(event.target.value);
    }

    function updateAccountOverdueFilter(event) {
        console.log(event.target.value)
        setAccountOverdueFilter(event.target.value);
    }

    function displayFilter() {
        return (
            <div className="row">
                <div className="col-12 col-md-4">
                    <label for="accountStatusFilter">Filter by Account Status</label>
                    <select className="form-control" 
                        name="accountStatusFilter" 
                        value={accountStatusFilter} 
                        onChange={updateAccountStatusFilter}
                    >
                        <option value="All">All</option>
                        <option value="Active">Active</option>
                        <option value="Locked">Locked</option>
                        <option value="Pending">Pending</option>
                    </select>
                </div>
                <div className="col-12 col-md-4">
                    <label for="accountOverdueFilter">Filter by Tardiness</label>
                    <select className="form-control" 
                        name="accountOverdueFilter" 
                        value={accountOverdueFilter} 
                        onChange={updateAccountOverdueFilter}
                    >
                        <option value="All">All</option>
                        <option value="Overdue">Overdue</option>
                        <option value="On Time">On Time</option>
                    </select>
                </div>
            </div>
        )
    }

    function redirectToAccount(event) {
        let accountId = event.target.value;
    
        history.push("/staff/Account/" + accountId);
    }

    function createHeadings(appStore) {
        //Creates the headings for the react-table
        const columns =
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <div>
                            <button className="btn btn-light" value={props.cell.value} onClick={redirectToAccount}>
                                Edit
                            </button>
                        </div>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white" }  
                    }
                },
                {
                    Header: "Student Name", accessor: "col2",
                    props: {
                        colSpan: "1", style: { width: "20%" }
                    }
                },
                { Header: "Employer Name", accessor: "col3", props: { colSpan: "1", style: { width: "15%" } } },
                {
                    Header: "Supervisor Name", accessor: "col4", props: { colSpan: "1", style: { width: "15%" } }
                },
                {
                    Header: "FOPAL", accessor: "col5", props: { colSpan: "1", style: { width: "10%" } }
                },
                {
                    Header: "Account Status", accessor: "col6",
                    Cell: (props) => (
                        <div>
                            <AccountStateButton badge={true} accountId={props.cell.value} store={appStore} onClick={redirectToAccountStatus}/>
                        </div>
                    ),
                    props: {
                        colspan: "1", style: { colSpan: "1", style: { width: "10%" } }
                    }
                },
                {
                    Header: "Overdue", accessor: "col7",
                    Cell: (props) => (
                        <div>
                            <AccountOverdueButton badge={true} accountId={props.cell.value} store={appStore}/>
                        </div>
                    ),
                    props: {
                        colspan: "1", style: { colSpan: "1", style: { width: "10%" } }
                    }
                },
                {
                    Header: "Award Amount", accessor: "col8", props: { colSpan: "1", style: { width: "20%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
            ];

        return columns;
    }

    function formatData(accounts) {

        const data = accounts.map((account) => {
            account.include(["student", "employer", "supervisor"])
            return {
                col1: account.id,
                col2: account.student.name,
                col3: account.employer.name,
                col4: account.supervisor.name,
                col5: account.fopal,
                col6: account.id,
                col7: account.id,
                col8: "$" + account.student.awardAmount.toFixed(2)
            }
        });

        return data;
    }

    const passesAccountStatusFilter = function(account) {
        console.log(account)
        if (account.accountStatusChanges.length == 0) {
            if (accountStatusFilter === "Active") {
                return true;
            }
            return false;
        }

        let currAccountStatus = account.accountStatusChanges[account.accountStatusChanges.length - 1];
        if (accountStatusFilter === "Active") {
            if (currAccountStatus.status === "Active") {
                return true;
            }
            return false;
        }
        if (accountStatusFilter === "Locked") {
            if (currAccountStatus.status === "Locked") {
                return true;
            }
            return false;
        }

        if (accountStatusFilter === "Pending") {
            if (currAccountStatus.status === "Pending") {
                return true;
            }
            return false;
        }

        return true
    }

    const passesAccountOverdueFilter = function(account) {
        let payPeriods = account.getPayPeriods();

        let overdue = payPeriods["unsubmitted"].length > 3

        if (accountOverdueFilter === "Overdue") {
            return overdue;
        }
        else if (accountOverdueFilter === "On Time") {
            return !overdue;
        }
    }

    let accounts = props.store.accounts.collection;
    //Filter for overdue accounts
    if (accountStatusFilter !== "All" || accountOverdueFilter !== "All") {
        accounts = accounts.filter(account => {

            let passedAccountStatusFilter = true;
            if (accountStatusFilter !== "All") {
                passedAccountStatusFilter =  passesAccountStatusFilter(account)
            }

            let passedAccountOverdueFilter = true;
            if (accountOverdueFilter !== "All") {
                passedAccountOverdueFilter =  passesAccountOverdueFilter(account)
            }

            return passedAccountStatusFilter && passedAccountOverdueFilter;
        });
    }

    accounts.sort((a,b) => {
        a = a.include(["student"])
        b = b.include(["student"])

        if(a.student.lastName.toLowerCase() > b.student.lastName.toLowerCase()) {
            return 1;
        }
        else if(b.student.lastName.toLowerCase() > a.student.lastName.toLowerCase()) {
            return -1;
        }
        else {
            if(a.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                return 1;
            }
            else if(b.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                return -1;
            }
            return 0
        }
    });

    const columns = createHeadings(props.store)
    const data = formatData(accounts);

    return (
        <React.Fragment>
            {displayFilter()}
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{}}
                rowProps={{}}
                columns={columns}
                data={data} />
        </React.Fragment>
    );

}

export {AllAccountsSummary};
